import React, { useEffect, useState } from 'react';
import { Crawler } from 'es6-crawler-detect';
import { jsx as _jsx } from "react/jsx-runtime";

var getAutoplayValue = function getAutoplayValue() {
  try {
    var _navigator;

    var userAgent = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent;
    var detector = new Crawler();

    if (!userAgent || detector.isCrawler(userAgent)) {
      return '';
    }

    return '?autoplay=yep';
  } catch (_unused) {
    return '';
  }
};

export var BoardEmbed = function BoardEmbed(_ref) {
  var boardId = _ref.boardId;

  var _useState = useState(''),
      autoplay = _useState[0],
      setAutoplay = _useState[1];

  useEffect(function () {
    setAutoplay(getAutoplayValue());
  }, []);
  return /*#__PURE__*/_jsx("iframe", {
    src: "https://miro.com/app/embed/".concat(boardId, "/").concat(autoplay),
    "data-testid": "board-preview-frame",
    title: 'Board preview frame',
    allowFullScreen: true
  });
};